import { useEffect, useRef } from "react";

/**
 * Scrolls the returned container back into view whenever the step changes, so
 * Back/Next never land the user halfway down a long form. The initial render is
 * skipped to avoid yanking the page on load.
 */
export function useScrollToTopOnStepChange<T extends HTMLElement>(step: number) {
	const containerRef = useRef<T>(null);
	const previousStepRef = useRef(step);

	useEffect(() => {
		if (previousStepRef.current === step) {
			return;
		}
		previousStepRef.current = step;

		const container = containerRef.current;
		if (!container) {
			return;
		}

		const prefersReducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;

		container.scrollIntoView({
			behavior: prefersReducedMotion ? "auto" : "smooth",
			block: "start",
		});
	}, [step]);

	return containerRef;
}
